import { render, staticRenderFns } from "./ElPageCover.vue?vue&type=template&id=717ac24e&"
import script from "./ElPageCover.vue?vue&type=script&lang=js&"
export * from "./ElPageCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports